import React from 'react';
import {useSelector} from "react-redux";
import {find, get, filter} from "lodash";

import Card from 'common/challengeNew/Card';
import {getStudentStreams} from "../../utils";


export default function () {
    const lesson = useSelector(state => state.lesson);
    const streams = useSelector(state => state.streams);
    const stream_entities = useSelector(state => state.challenge_version_stream_entities);
    const selected_stream_id = useSelector(state => state.teacher_facilitation_selected_stream_id);
    const selected_card_index = useSelector(state => state.teacher_facilitation_selected_card_index);

    const se = get(stream_entities, selected_card_index);
    const selected_stream = find(streams, {id: selected_stream_id});
    const current_stream_entity = {
        ...se,
        responses: filter(selected_stream.responses, {stream_entity_id: se.id}),
        votes: filter(selected_stream.votes, {stream_entity_id: se.id})
    };

    function renderPreview() {
        if (current_stream_entity) {
            return (
                <div className="challenge-preview-adjustment">
                    <Card
                        challenge_version={lesson.challenge_version}
                        stream_entity={current_stream_entity}
                        lesson={lesson}
                        is_preview={true}
                    />
                </div>
            );
        }
    }

    return (
        <div className="bystudent-stream-container">
            {renderPreview()}
        </div>
    );
}
